/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdRangeInputPopupProps, TdRangeInputProps } from './type';

export const rangeInputDefaultProps: TdRangeInputProps = {
  borderless: false,
  clearable: false,
  readonly: false,
  readOnly: false,
  separator: '-',
  showClearIconOnEmpty: false,
  size: 'medium',
  status: 'default',
  defaultValue: [],
};

export const rangeInputPopupDefaultProps: TdRangeInputPopupProps = {
  autoWidth: false,
  readonly: false,
  readOnly: false,
  status: 'default',
};
